// extracted by mini-css-extract-plugin
module.exports = {"container":"idt-gridwithculling_container__uhbh_","view":"idt-gridwithculling_view__11dil"};